const getSecurityVersion = (val: string): string => {
  return val.includes('#{') || !val ? 'v0' : val;
};

export const environment = {
  production: true,
  env: '#{ENVIRONMENT}#',
  TENANT_ID: '#{TENANT_ID}#',
  firebase: {
    apiKey: '#{PRICING_FIREBASE_API_KEY}#',
    authDomain: '#{PRICING_FIREBASE_AUTH_DOMAIN}#',
    projectId: '#{PRICING_FIREBASE_PROJECT_ID}#',
    storageBucket: '#{PRICING_FIREBASE_STORAGE_BUCKET}#',
    messagingSenderId: '#{PRICING_FIREBASE_MESSAGING_SENDER_ID}#',
    appId: '#{PRICING_FIREBASE_APP_ID}#',
    measurementId: '',
    databaseURL: '',
  },
  OIDC_PROVIDER: '#{OIDC_PROVIDER}#',
  globalHostName: '#{GLB_HOSTNAME}#',
  // FIREBASE LOG CONFIGS
  FIREBASE_LOG_COLLECTION: '#{FIREBASE_LOG_COLLECTION}#', // The default name of the log collection
  FIREBASE_LOG_RETENTION_AGE: '#{FIREBASE_LOG_RETENTION_AGE}#', // The default TTL for the log entry (in days)
  FIREBASE_LOG_ENABLED: '#{FIREBASE_LOG_ENABLED}#', // Log enabled flag
  AGGRID_LICENSE_KEY: '#{AGGRID_LICENSE_KEY}#',
  APIGEEX_HOST_URL: '#{APIGEEX_HOST_URL}#',
  APIGEE_PROTOCOL_CARRIER: '#{APIGEE_PROTOCOL_CARRIER}#',
  APIGEE_ROUTING_PROTOCOL_GROUP_COUNT:
    '#{APIGEE_ROUTING_PROTOCOL_GROUP_COUNT}#',
  APIGEE_ROUTING_PROTOCOL_GROUP: '#{APIGEE_ROUTING_PROTOCOL_GROUP}#',
  APIGEE_PROTOCOL_GROUP_STATIONS_UPDATE:
    '#{APIGEE_PROTOCOL_GROUP_STATIONS_UPDATE}#',
  APIGEE_GET_STATIONS_COUNT: '#{APIGEE_GET_STATIONS_COUNT}#',
  APIGEE_PROTOCOL_GROUP_STATIONS: '#{APIGEE_PROTOCOL_GROUP_STATIONS}#',
  APIGEE_GET_STATIONS: '#{APIGEE_GET_STATIONS}#',
  APIGEE_GET_CUSTOMERS: '#{APIGEE_GET_CUSTOMERS}#',
  APIGEE_GET_STATION_ASSIGNMENTS_COUNT:
    '#{APIGEE_GET_STATION_ASSIGNMENTS_COUNT}#',
  APIGREE_GET_ROUTE: '#{APIGEE_GET_ROUTE}#',
  APIGEE_ROUTING_PROTOCOL: '#{APIGEE_ROUTING_PROTOCOL}#',
  APIGEE_ROUTING_PROTOCOL_EXCEPTIONS: '#{APIGEE_ROUTING_PROTOCOL_EXCEPTIONS}#',
  APIGEE_EXCEPTIONS_COUNT: '#{APIGEE_EXCEPTIONS_COUNT}#',
  APIGEE_ROUTING_PROTOCOL_COUNT: '#{APIGEE_ROUTING_PROTOCOL_COUNT}#',
  APIGEE_SPLC_STATIONS: '#{APIGEE_SPLC_STATIONS}#',
  APIGEE_GET_COMMODITIES: '#{APIGEE_GET_COMMODITIES}#',
  APIGEE_JUNCTION_SYNONYM_COUNT: '#{APIGEE_JUNCTION_SYNONYM_COUNT}#',
  APIGEE_JUNCTION_SYNONYM: '#{APIGEE_JUNCTION_SYNONYM}#',
  APIGEE_PERMISSIONS_GET_ENDPOINT: '#{APIGEE_PERMISSIONS_GET_ENDPOINT}#',
  APIGEE_USER_PREFERENCES_ENDPOINT: '#{APIGEE_USER_PREFERENCES_ENDPOINT}#',
  APIGEE_JUNCTION_SYNONYMS: '#{APIGEE_JUNCTION_SYNONYMS}#',
  APIGEE_GET_JUNCTIONS: '#{APIGEE_GET_JUNCTIONS}#',
  ROUTING_PROTOCOL_GRID_PAGE_SIZE: Number(
    '#{ROUTING_PROTOCOL_GRID_PAGE_SIZE}#'
  ),
  ROUTING_PROTOCOL_GRID_API_CONCURRENCY: Number(
    '#{ROUTING_PROTOCOL_GRID_API_CONCURRENCY}#'
  ),
  STATIONS_GRID_PAGE_SIZE: Number('#{STATIONS_GRID_PAGE_SIZE}#'),
  STATIONS_GRID_API_CONCURRENCY: Number('#{STATIONS_GRID_API_CONCURRENCY}#'),
  ROUTING_PROTOCOL_GROUP_STATIONS_MAX_RECORDS: Number(
    '#{ROUTING_PROTOCOL_GROUP_STATIONS_MAX_RECORDS}#'
  ),
  STATE_TTL_MS: Number('#{STATE_TTL_MS}#') || undefined,
  SECURITY_VERSION: getSecurityVersion('#{SECURITY_VERSION}#'),
};
